// extracted by mini-css-extract-plugin
module.exports = {"nav":"PurchaseNav_nav__nduA_","navItem":"PurchaseNav_navItem__3mrmA","active":"PurchaseNav_active__1SfOd"};